import { JSX, useState } from "react";
import { TopCondition } from "@app/projects/servicing-provider";
import MultiselectDropdown from "@app/shared/checkbox-dropdown/MultiselectDropdown";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";

/**
 * Properties for the TopConditionsFilter component
 */
interface TopConditionsProps {
  containerClassName?: string,
  disabled: boolean,

  /**
   * List of top conditions to display in the dropdown
   */
  topConditions: DropdownItem<TopCondition>[];

  onSelectionChanged?: (selectedTopConditions: DropdownItem<TopCondition>[]) => void;
  selectedTopConditions: DropdownItem<TopCondition>[];
  setSelectedTopConditions: (selectedTopConditions: DropdownItem<TopCondition>[]) => void;
  testId: string;
  title: string;
}

/**
 * TopConditionsFilter component
 */
const TopConditionsFilter = (props: TopConditionsProps): JSX.Element => {
  const [searchText, setSearchText] = useState("");
  const [filteredTopConditions, setFilteredTopConditions] = useState<DropdownItem<TopCondition>[]>([]);

  /**
   * Handler for when the search text in the top conditions dropdown changes
   * @param searchText - The new search text
   */
  const onSearchTextChange = (searchText: string) => {
    setSearchText(searchText);
    const filtered = searchText === "" ? [] : props.topConditions.filter(option =>
      option.name.toLowerCase().includes(searchText.toLowerCase()));
    setFilteredTopConditions(filtered);
  };

  return (
    <MultiselectDropdown
      containerClassName={props.containerClassName ?? "d-block"}
      customSelectInputText={null}
      disabled={props.disabled}
      items={!!searchText ? filteredTopConditions : props.selectedTopConditions.concat(filteredTopConditions)}
      onSelectionChanged={(selectedValues: DropdownItem<TopCondition>[]) => { props.setSelectedTopConditions(selectedValues) }}
      onSearchTextChange={onSearchTextChange}
      label={props.title}
      selectedItems={props.selectedTopConditions}
      testId={props.testId}
      hideSelectAll={true}
      showTooltipOnOverflow={true}
      validationTooltipContent={"This dropdown searches the top 5 condition codes across all available lines of business, regardless of your current filters."}
      autofocusSearch={true}
    />
  )
}

export default TopConditionsFilter;